import Layout, { Content, Footer, Header } from 'antd/lib/layout/layout';
import { Col, Image, Row } from 'antd';
import { Outlet, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectors } from 'app/services/session';
import { Paths } from 'constants/index';
import Language from 'containers/Language/Language';
import { useScreenBreakpoint } from 'hooks';
import './styles.less';

// Minimal shell for the public pages: the tool overview (/tools/overview/:barcode, through
// ToolOverviewShell) and the logger overview (/loggers/overview/:barcode, used directly so it looks the
// same whether or not somebody is logged in). Same header colours and wordmark as the private
// containers/Layout/Layout.tsx, without the sidebar menu and the mobile bottom bar. There is no login
// button: like everywhere else, the logo leads to the dashboard, or to the login screen when nobody is
// logged in.
const PublicLayout = () => {
  const navigate = useNavigate();
  const isAuthenticated = useSelector(selectors.isAuthenticated);
  const { isMobile } = useScreenBreakpoint();

  return (
    <Layout className="public-layout">
      <Header className="layout-header">
        <Row justify="space-between" align="middle" style={{ height: '100%' }}>
          <Col>
            <Image
              width={120}
              preview={false}
              src={process.env.PUBLIC_URL + '/logo_white.png'}
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(isAuthenticated ? Paths.DASHBOARD : Paths.LOGIN)}
            />
          </Col>
          <Col>
            <Language theme="dark" />
          </Col>
        </Row>
      </Header>
      <Content className="public-layout-content">
        <Outlet />
      </Content>
      {!isMobile && (
        <Footer className="public-layout-footer">
          Running on {process.env.REACT_APP_ENVIRONMENT}
        </Footer>
      )}
    </Layout>
  );
};

export default PublicLayout;
